import {Component} from "@angular/core";
import {FUIDeprecatedAutocompleteControlComponent} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-localisation-autocomplete-control",
    styleUrls: ["./localisation-autocomplete-control.component.scss"],
    templateUrl: "./localisation-autocomplete-control.component.html"
})
export class LocalisationAutoCompleteControlComponent extends FUIDeprecatedAutocompleteControlComponent {

}
